import {
  trackSignup as trackSignupFB,
  trackLogin as trackLoginFB,
  trackSubscription as trackSubscriptionFB,
  trackPageView as trackPageViewFB,
  trackCustomEvent as trackCustomEventFB,
  initFacebookPixel,
} from './facebookPixel';

const GA_PROPERTY_ID = process.env.REACT_APP_GA_PROPERTY_ID;

const checkGAPresence = () =>
  typeof window.gtag === 'function' && Boolean(GA_PROPERTY_ID);

export const initGA = () => {
  if (!GA_PROPERTY_ID) {
    console.warn('Google Analytics property ID is not set');
    return;
  }

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
  window.gtag('js', new Date());
  window.gtag('config', GA_PROPERTY_ID, { anonymize_ip: true });
  window.gtag('config', GA_PROPERTY_ID, { send_page_view: false });
};

export const sendPageViewGA = (page) =>
  checkGAPresence() &&
  window.gtag('event', 'page_view', {
    ...page,
    send_to: GA_PROPERTY_ID,
  });

// Combined page view tracking for both GA and Facebook Pixel
export const trackPageView = (page = {}) => {
  sendPageViewGA(page);
  trackPageViewFB(page);
};

export const sendEventGA = (action, event) =>
  checkGAPresence() &&
  window.gtag('event', action, {
    ...event,
    send_to: GA_PROPERTY_ID,
  });

// Combined tracking functions for both GA and Facebook Pixel
export const trackSignup = (method = 'email') => {
  sendEventGA('sign_up', { method });
  trackSignupFB(method);
};

export const trackLogin = (method = 'email') => {
  sendEventGA('login', { method });
  trackLoginFB(method);
};

export const trackSubscription = (subscriptionData) => {
  sendEventGA('purchase', {
    userId: subscriptionData.userId,
    value: parseFloat(subscriptionData.amount),
    currency: subscriptionData.currency || 'EUR',
    product: subscriptionData.plan,
  });
  trackSubscriptionFB(subscriptionData);
};

// Track custom events (non-standard Meta Pixel events)
export const trackCustomEvent = (eventName, parameters = {}) => {
  sendEventGA(eventName, parameters);
  trackCustomEventFB(eventName, parameters);
};

// Initialize both analytics
export const initAnalytics = () => {
  initGA();
  initFacebookPixel();
  // Track initial page view
  trackPageView();
};
